export default {
  "content": "<g clip-path=\"url(#clip0_773_2075)\"><path d=\"M10.58 15.146a.533.533 0 01-.747.02l-6.7-6.24c-.3-.28-.466-.673-.466-1.08.006-.406.18-.8.486-1.073L9.807.806a.534.534 0 01.746.034l.593.64c.2.22.187.56-.033.76L4.827 7.866l6.333 5.894c.22.2.226.546.02.76l-.6.626z\" fill=\"#3F4450\"/></g><defs><clipPath id=\"clip0_773_2075\"><path fill=\"#fff\" d=\"M0 0h16v16H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "16",
    "height": "16",
    "viewBox": "0 0 16 16",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};